import { useId } from 'react';
import FieldFrame from './FieldFrame.jsx';
import Icon from './Icon.jsx';
import { getFieldDescribedBy } from './getFieldDescribedBy.js';

/** Single-line text field with optional label, hint, error and leading icon. Mono for IDs and keys. */
const Input = ({ label, hint, error, icon, mono = false, size = 'md', id: givenId, ...rest }) => {
  const generatedId = useId();
  const id = givenId ?? generatedId;
  const classes = ['comp-input', `comp-input--${size}`];
  if (mono) {
    classes.push('comp-input--mono');
  }
  if (icon) {
    classes.push('comp-input--with-icon');
  }

  return (
    <FieldFrame id={id} label={label} hint={hint} error={error}>
      <div className={classes.join(' ')}>
        {icon && <Icon icon={icon} />}
        <input {...rest} id={id} className="comp-input__control" aria-invalid={error ? 'true' : undefined} aria-describedby={getFieldDescribedBy({ id, hint, error })} />
      </div>
    </FieldFrame>
  );
};

export default Input;
